<template>
    <div>
        <b-tab :title="$tc('message.results',2)" :active="pathHas('resultatLabo') || pathHas('resultatImagerie') ">
            <div id="resultatLabo">
                <h3 class="text-center"> {{ $tc('message.labResults', 2) }}</h3>
                <b-link class="ml-4" :to="{ name: 'add-lab-result' , params: { file: this.file_id }}" variant="primary" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                    <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.labResults',2) }}
                </b-link>

                <b-card-body>
                    <vue-good-table v-if="notEmpty(mResultatsLabo)" id="labResult" :columns="labResultsColumns" :rows="labResultsRows" :search-options="enabled" :pagination-options="paginationOptions" :sort-options="sort" @on-row-click="onLabResultRowClick" />
                </b-card-body>
            </div>
            <div id="resultatImagerie">
                <h3 class="text-center"> {{ $tc('message.imageryResults', 2) }}</h3>

                <b-link class="ml-4 mr-2" :to="{ name: 'add-imagery-result' , params: { file: this.file_id }}" variant="primary" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                    <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.imageryResults',2) }}
                </b-link>

                <b-card-body>
                    <vue-good-table v-if="notEmpty(mResultatsImagerie)" id="imgResult" :columns="imgResultsColumns" :rows="imgResultsRows" :search-options="enabled" :pagination-options="paginationOptions" :sort-options="sort" @on-row-click="onImgResultRowClick" />
                </b-card-body>
            </div>
        </b-tab>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import moment from "moment";
export default {
    name: "Resultat",
    methods: {
        filterResult(sArray, mArray) {
            if (this.filteredValue == 1) {
                mArray = sArray;
            } else if (this.filteredValue == 2) {
                //Non archivés
                mArray = _.filter(mArray, function (medecine) {
                    return _.isNull(medecine.archievedAt);
                })
            } else if (this.filteredValue == 3) {
                //Non transmis
                mArray = _.filter(mArray, function (medecine) {
                    return _.isNull(medecine.passedAt);
                })
            } else if (this.filteredValue == 4) {
                //Archivés
                mArray = _.filter(mArray, function (medecine) {
                    return !_.isNull(medecine.archievedAt);
                })
            } else if (this.filteredValue == 5) {
                //Transmis
                mArray = _.filter(mArray, function (medecine) {
                    return !_.isNull(medecine.passedAt);
                })
            }
            return mArray;
        },
    },
    computed: {
         ...mapGetters(["file"]),

        mMedicalFile: function () {
            return _.isUndefined(this.file) ? [] : this.file;
        },
        mResultatsLabo: function () {
            return (typeof this.mMedicalFile.resultats_labo == "object" ? this.mMedicalFile.resultats_labo : []);
        },
        mResultatsImagerie: function () {
            return (typeof this.mMedicalFile.resultats_imagerie == "object" ? this.mMedicalFile.resultats_imagerie : []);
        },
        labResultsRows: function () {
            let lrArray = [];
            let self = this;

            _.forEach(self.mResultatsLabo, function (resultat) {
                lrArray.push({
                    description: resultat.description,
                    date: resultat.date,
                    slug: resultat.slug,
                    passedAt: resultat.passed_at,
                    archievedAt: resultat.archived_at
                });
            });
            let sArray = lrArray;
            //lrArray = self.filterResult(sArray, lrArray);
            return lrArray;
        },

        imgResultsRows: function () {
            let lrArray = [];
            let self = this;
            _.forEach(self.mResultatsImagerie, function (resultat) {
                lrArray.push({
                    description: resultat.description,
                    date: resultat.date,
                    slug: resultat.slug,
                    passedAt: resultat.passed_at,
                    archievedAt: resultat.archived_at
                })
            })
            let sArray = lrArray;
            //lrArray = self.filterResult(sArray, lrArray);
            return lrArray;
        },
    },
    props: ['hasAdminRole', 'hasMedecinControleRole', 'hasAssistante', 'hasPraticienRole', 'file_id'],

    data() {
        return {
            labResultsColumns: [{
                    label: 'Description',
                    field: 'description',
                },
                {
                    label: this.$i18n.t('message.date'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
            ],

            imgResultsColumns: [{
                    label: 'Description',
                    field: 'description',
                },
                {
                    label: this.$i18n.t('message.date'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
            ],
            paginationOptions: {
                enabled: true,
                mode: 'records',
                perPageDropdown: [3, 6, 10]
            },

            enabled: {
                enabled: true
            },

            sort: {
                enabled: true,
                initialSortBy: {
                    field: 'date',
                    type: 'desc'
                }
            },
            
        }
    },
    validations() {
        return {
            form: {
                responsable:{},
            }
        }
	},
    methods: {
        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },
        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },  
        onPrescriptionRowClick(params) {
            this.$router.push({
                name: 'prescription',
                params: {
                    prescription: params.row.slug
                }
            });
        },
        pathHas(element) {
        let result = (this.$route.fullPath).includes(element);
            if (result) {
                if ($('#' + element).length) {
                    document.getElementById(element).scrollIntoView(top);
                }
            }

            return result;
        },
        onImgResultRowClick(params) {
            this.$router.push({
                name: 'imagery-result',
                params: {
                    result: params.row.slug
                }
            });
        },
        onLabResultRowClick(params) {
            this.$router.push({
                name: 'lab-result',
                params: {
                    result: params.row.slug
                }
            });
        },
        notEmpty(item) {
            return item.length > 0;
        },
    },
    mounted() {
        //console.log("file ", this.file.resultats_labo)
    }
}
</script>
<style lang="">
    
</style>